import { useQuery } from "@tanstack/react-query";
import { fetchSentimentSummary } from "../../api";

interface Props {
  product: string;
  dateFrom?: string;
  dateTo?: string;
}

export default function AISummary({ product, dateFrom, dateTo }: Props) {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["sentimentSummary", product, dateFrom ?? "", dateTo ?? ""],
    queryFn: () => fetchSentimentSummary(product, dateFrom, dateTo),
    enabled: !!product,
    staleTime: 5 * 60 * 1000,
  });

  if (isLoading) {
    return (
      <div className="space-y-2">
        {[1, 0.8, 0.6].map((w, i) => (
          <div key={i} className="h-2.5 animate-pulse rounded bg-surface-sunken" style={{ width: `${w * 100}%` }} />
        ))}
      </div>
    );
  }
  if (isError) return <p className="text-[12px] text-ink-faint">摘要生成失败</p>;
  if (data) return <p className="text-[13px] leading-7 text-ink-secondary">{data.summary}</p>;
  return null;
}
